import { defaultColumns, defaultSort } from '../../components/processes/declutters/reports/columns';

export default {
  state: {
    declutterReports: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'ascending',
    },
  },
  getters: {
    declutterReports: state => state.declutterReports,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setDeclutterReports(state, declutterReports) {
      state.declutterReports = declutterReports;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/declutter-report-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'declutter-report-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'declutter-report-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const declutterReports = await axios.get('api/declutter-reports' + (query || ''));
        commit('setDeclutterReports', declutterReports);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      return await axios.get(`api/declutter-reports/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/declutter-reports', payLoad);
    },
    async update({ commit }, payLoad) {
        await axios.put('api/declutter-reports', payLoad);
    },

    async delete({ commit }, id) {
      await axios.delete('api/declutter-reports/' + id);
    },

    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/declutter-report-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'DeclutterReports'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
